<div>
  <span class="medium-type ps-xsmall-r">{{
    'payment.paymentMethod.' + (payment.mopType === PAYMENT_TYPE.BANK ? payment.mopSubType : payment.mopType)
      | finLocalization
  }}</span>
  <span *ngIf="isCreditCard">{{ 'payment.paymentCard.brand.' + payment.mopSubType | finLocalization }}</span>
</div>
<div>
  <span>{{ payment.id }}</span>
  <span class="align-right ps-xsmall-l">
    <fcom-icon *ngIf="icon" [category]="iconCategory" [name]="icon" class="icon-medium-payment"></fcom-icon>
  </span>
</div>
